module.exports = __webpack_public_path__ + "media/images/logo-no-text-b7c9e581a4b482851de726eabfb3c4c3.png";